export const APPOINTMENT_COLORS = {
  travel: '#6574CC',
  work: '#2EB5D9',
} as const

export const TASK_COLORS = {
  travel: '#CC8A65',
  work: '#D96868',
} as const

export const COMPLETED_COLOR = '#3BC67D'
export const COMPLETED_TRAVEL_COLOR = '#8B97D9'
export const EXPIRED_COLOR = '#9CA3AF'

export const COMPLETED_TASK_COLORS = {
  travel: '#3BC67D',
  work: '#3BC67D',
} as const

export const INACTIVE_APPOINTMENT_STATUSES = new Set(['COMPLETED', 'EXPIRED'])

export function getTaskColors(status: string): { workColor: string; travelColor: string } {
  if (status === 'COMPLETED') {
    return { workColor: COMPLETED_TASK_COLORS.work, travelColor: COMPLETED_TASK_COLORS.travel }
  }
  return { workColor: TASK_COLORS.work, travelColor: TASK_COLORS.travel }
}

export function getAppointmentColors(status: string): { workColor: string; travelColor: string } {
  if (status === 'COMPLETED') {
    return { workColor: COMPLETED_COLOR, travelColor: COMPLETED_TRAVEL_COLOR }
  }
  if (status === 'EXPIRED') {
    return { workColor: EXPIRED_COLOR, travelColor: EXPIRED_COLOR }
  }
  if (status === 'COMPLETED_WITH_FOLLOW_UP') {
    return { workColor: '#ED9E42', travelColor: COMPLETED_TRAVEL_COLOR }
  }
  return { workColor: APPOINTMENT_COLORS.work, travelColor: APPOINTMENT_COLORS.travel }
}
